import { z } from "zod";

export const VOYAGE_EMBEDDING_MODEL = "voyage-multimodal-3.5";

export const EMBEDDING_PROVIDER_ID_VALUES = ["VOYAGE"] as const;
export const EmbeddingProviderIdEnum = z.enum(EMBEDDING_PROVIDER_ID_VALUES);
export type EmbeddingProviderId = z.infer<typeof EmbeddingProviderIdEnum>;
export const EMBEDDING_PROVIDER_ID = EmbeddingProviderIdEnum.enum;

export const EmbeddingProviderGenerateParamsSchema = z.discriminatedUnion(
  "type",
  [
    z.object({
      type: z.literal("asset"),
      assetIds: z
        .array(z.string())
        .describe("One or more asset IDs to embed as a single interleaved input"),
    }),
    z.object({
      type: z.literal("text"),
      text: z.string().describe("Raw text to embed"),
    }),
  ],
);

export type EmbeddingProviderGenerateParams =
  | {
      type: "asset";
      assetIds: string[];
    }
  | {
      type: "text";
      text: string;
    };

export const EmbeddingResultSchema = z.object({
  assetId: z.string().optional(),
  text: z.string().optional(),
  embedding: z.array(z.number()),
});
export type EmbeddingResult = z.infer<typeof EmbeddingResultSchema>;
